module.exports = __webpack_public_path__ + "img/info.402dd2f4.svg";